var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Box } from "theme-ui";
import { ArtDirectedImage, SentenceAndLinks, Fonts, FontWeight, LineHeights } from "../../../index";
import { HeroContainer, HeroTextContainer } from "./Hero";
export const StatementHero = (_a) => {
    var { statement, sentence, label, children, imageUrl, imageNode, imageAlt, hasGradientOverlay = true, objectPositionLeft = "center", objectPositionTop = "center", videoURL, hlsVideoURL, mode = "dark", mark_as_h1 = false } = _a, props = __rest(_a, ["statement", "sentence", "label", "children", "imageUrl", "imageNode", "imageAlt", "hasGradientOverlay", "objectPositionLeft", "objectPositionTop", "videoURL", "hlsVideoURL", "mode", "mark_as_h1"]);
    return (_jsxs(HeroContainer, Object.assign({}, props, { mode: mode, children: [_jsx(ArtDirectedImage, { imageUrl: imageUrl, imageAlt: imageAlt, imageNode: imageNode, videoURL: videoURL, hlsVideoURL: hlsVideoURL, objectPositionLeft: objectPositionLeft, objectPositionTop: objectPositionTop, hasGradientOverlay: hasGradientOverlay }), _jsx(Box, { sx: {
                    position: "absolute",
                    width: "100%",
                    alignSelf: "center",
                    textAlign: "center"
                }, children: _jsx(Box, { as: mark_as_h1 ? "h1" : "h2", className: "color-mode-title", sx: {
                        fontFamily: Fonts.display,
                        fontWeight: FontWeight.displayRegular,
                        fontSize: ["scale5", null, "scale8", "scale10"],
                        lineHeight: LineHeights.largeHeadings,
                        margin: "auto",
                        maxWidth: ["11ch", null, "18ch", "18ch"],
                        whiteSpace: "pre-wrap"
                    }, children: statement }) }), _jsx(HeroTextContainer, { children: _jsx(SentenceAndLinks, { sentence: sentence, label: label, children: children }) })] })));
};
//# sourceMappingURL=StatementHero.js.map